/* eslint-disable */

import React from "react";
import { connect } from "react-redux";
import { loadSubscriptionsStart } from "../../../../Actions";
import { withTranslation } from "react-i18next";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import AppsIcon from "@material-ui/icons/Apps";
import DashboardIcon from "@material-ui/icons/Dashboard";
class MainPage extends React.Component {
  // Load the subscriptions
  componentDidMount() {
    this.props.dispatch(loadSubscriptionsStart());
  }

  render() {
    
    const { user } = this.props;
    const { t: translate } = this.props;

    // Display name only (never the email)
    const getUserName = () => {
      const profile = (user && user.profile) || {};
      const fullName = [profile.given_name, profile.family_name]
        .filter(Boolean)
        .join(" ");
      const name = fullName || profile.name || profile.preferred_username || "";
      return name.includes("@") ? name.split("@")[0] : name;
    };

    // Open external application
    const devpage = () => {
      window.open("https://dfdemo.minerva.app", "_blank");
    };

    // Navigate to dashboard
    const wholesell = () => {
      window.location.href = "https://demolms.minerva.app/home/e79fd120-30ed-46eb-b4b1-54b43b9d1d14/19ce9808-de97-4c75-9089-0df544835f7c";
    };

    // Applications shown on the page
    const applications = [
      {
        id: "developer",
        title: "Development Finance",
        description: "Open the development finance",
        icon: AppsIcon,
        action: devpage,
      },
      {
        id: "wholesale",
        title: "Wholesale Application",
        description: "Open the wholesale dashboard",
        icon: DashboardIcon,
        action: wholesell,
      },
    ];

    // Handle application click
    const handleApplicationClick = (application) => {
      if (application.action) {
        application.action();
      }
    };

    return (
      <div
        style={{
          marginTop: "100px",
          textAlign: "center",
          alignItems: "center",
        }}
      >
        {user && (
          <div>
            <h3 className="welcomeText">
              {translate("Welcome")},{" "}
              {getUserName() || "Mister Unknown"}
            </h3>
          </div>
        )}

        {!user && (
          <div>
            <h3>You have been successfully logged out.</h3>
          </div>
        )}

        <main className="landing-content">
          <div className="content-wrapper">
            <div className="page-heading">
              {/* <span className="eyebrow">EQUIPPED PLATFORM</span> */}

              {/* <h4>Applications</h4> */}

              <p>Select an application to continue</p>
            </div>

            <div className="application-grid">
              {applications.map((application) => {
                const Icon = application.icon;

                return (
                  <div
                    key={application.id}
                    className="application-card"
                    onClick={() =>
                      handleApplicationClick(application)
                    }
                    role="button"
                    tabIndex={0}
                    onKeyDown={(event) => {
                      if (
                        event.key === "Enter" ||
                        event.key === " "
                      ) {
                        handleApplicationClick(application);
                      }
                    }}
                  >
                    <div className="card-top">
                      <div className="application-icon">
                        <Icon />
                      </div>

                      <div className="card-arrow">
                        <ArrowForwardIcon />
                      </div>
                    </div>

                    <div className="card-content">
                      <h2>{application.title}</h2>
                      <p>{application.description}</p>
                    </div>
                    
                    <div className="card-footer">
                      <span>Open application</span>
                      <ArrowForwardIcon />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </main>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
  };
}

export default withTranslation()(connect(mapStateToProps)(MainPage));

